import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import centralApiAxios from "../../axios/centralApiAxios";
import EnumRecordTypes from "../../enums/enumRecordTypes";

import {
  GET_COLLECTION_OPTIONS,
  GET_PAGE_DATA
} from "../actions";

import {
  getPageDataSuccess,
  getPageDataError,
  getCollectionOptionsSuccess,
  getCollectionOptionsError
} from "./actions";

export function* watchGetPageData() {
  yield takeEvery(GET_PAGE_DATA, getPageData);
}

const getPageDataAsync = async (payload) => {
  try {
    const dataReturned = await centralApiAxios.get("pages?id=" + payload.pageId);
    if (dataReturned.data) {
      return {
        pageData: dataReturned.data,
        message: null,
      };
    }
    return { message: "Get page data failed." };
  } catch (error) {
    return {
      message: "Get page data failed. ",
    };
  }
};

function* getPageData({ payload }) {
  try {
    const returnedData = yield call(getPageDataAsync, payload);
    if (!returnedData.message) {
      yield put(
        getPageDataSuccess(returnedData.pageData)
      );
    } else {
      yield put(getPageDataError(returnedData.message));
    }
  } catch (error) {
    yield put(getPageDataError(error));
  }
}

export function* watchGetCollectionOptions() {
  yield takeEvery(GET_COLLECTION_OPTIONS, getCollectionOptions);
}

const getCollectionOptionsAsync = async (payload) => {
  try {
    const dataReturned = await centralApiAxios.get("node_edges?trashed=false&from_node_id=" + payload.collectionId + "&to_enumrecordtype=" + EnumRecordTypes.Page);
    if (dataReturned.data) {
      let pageOptions = dataReturned.data.items.filter(copt => copt.recordType === EnumRecordTypes.NodeEdgeOption);
      pageOptions = pageOptions.sort((a, b) => a.weight - b.weight);
      let collectionOptionsData = {
        collectionId: payload.collectionId,
        collectionOptions: pageOptions
      }
      return {
        collectionOptionsData: collectionOptionsData,
        message: null,
      };
    }
    return { message: "Get collection options failed." };
  } catch (error) {
    return {
      message: "Get collection options failed. ",
    };
  }
};

function* getCollectionOptions({ payload }) {
  try {
    const returnedData = yield call(getCollectionOptionsAsync, payload);
    if (!returnedData.message) {
      yield put(
        getCollectionOptionsSuccess(returnedData.collectionOptionsData)
      );
    } else {
      yield put(getCollectionOptionsError(returnedData.message));
    }
  } catch (error) {
    yield put(getCollectionOptionsError(error));
  }
}

export default function* rootSaga() {
  yield all([
    fork(watchGetPageData),
    fork(watchGetCollectionOptions)
  ]);
}
